/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicationRefillAnalysis } from './MedicationRefillAnalysis';
import {
    MedicationRefillAnalysisFromJSON,
    MedicationRefillAnalysisFromJSONTyped,
    MedicationRefillAnalysisToJSON,
} from './MedicationRefillAnalysis';
import type { Prescription } from './Prescription';
import {
    PrescriptionFromJSON,
    PrescriptionFromJSONTyped,
    PrescriptionToJSON,
} from './Prescription';

/**
 * 
 * @export
 * @interface PharmacyAuthorizationAnalysis
 */
export interface PharmacyAuthorizationAnalysis {
    /**
     * 
     * @type {Prescription}
     * @memberof PharmacyAuthorizationAnalysis
     */
    generated_prescription?: Prescription;
    /**
     * 
     * @type {Array<MedicationRefillAnalysis>}
     * @memberof PharmacyAuthorizationAnalysis
     */
    medications: Array<MedicationRefillAnalysis>;
    /**
     * 
     * @type {string}
     * @memberof PharmacyAuthorizationAnalysis
     */
    pharmacy_reply_to?: string;
}

/**
 * Check if a given object implements the PharmacyAuthorizationAnalysis interface.
 */
export function instanceOfPharmacyAuthorizationAnalysis(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "medications" in value;

    return isInstance;
}

export function PharmacyAuthorizationAnalysisFromJSON(json: any): PharmacyAuthorizationAnalysis {
    return PharmacyAuthorizationAnalysisFromJSONTyped(json, false);
}

export function PharmacyAuthorizationAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyAuthorizationAnalysis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generated_prescription': !exists(json, 'generated_prescription') ? undefined : PrescriptionFromJSON(json['generated_prescription']),
        'medications': ((json['medications'] as Array<any>).map(MedicationRefillAnalysisFromJSON)),
        'pharmacy_reply_to': !exists(json, 'pharmacy_reply_to') ? undefined : json['pharmacy_reply_to'],
    };
}

export function PharmacyAuthorizationAnalysisToJSON(value?: PharmacyAuthorizationAnalysis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generated_prescription': PrescriptionToJSON(value.generated_prescription),
        'medications': ((value.medications as Array<any>).map(MedicationRefillAnalysisToJSON)),
        'pharmacy_reply_to': value.pharmacy_reply_to,
    };
}

